"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FETCH_ROOMS_SUCCESS = exports.FETCH_ROOMS_SUCCESS = "FETCH_ROOMS_SUCCESS";
var FETCH_ROOMS_FAILURE = exports.FETCH_ROOMS_FAILURE = "FETCH_ROOMS_FAILURE";
var FETCH_CHALLENGES_SUCCESS = exports.FETCH_CHALLENGES_SUCCESS = "FETCH_CHALLENGES_SUCCESS";
var FETCH_CHALLENGES_FAILURE = exports.FETCH_CHALLENGES_FAILURE = "FETCH_CHALLENGES_FAILURE";
var CREATE_ROOM_SUCCESS = exports.CREATE_ROOM_SUCCESS = "FETCH_CHALLENGES_SUCCESS";
var CREATE_ROOM_FAILURE = exports.CREATE_ROOM_FAILURE = "FETCH_CHALLENGES_FAILURE";
var LOADING_REQUEST = exports.LOADING_REQUEST = "LOADING_REQUEST";